export default __webpack_public_path__ + "static/media/create_nft_button.26ff7528.svg";